export enum KnowledgeCardsIntentType {
	PERSON = 'PERSON',
	TEAM = 'TEAM',
}

export enum KnowledgeCardsRowType {
	PERSON = 'PERSON',
	WORK = 'WORK',
}
